export default __webpack_public_path__ + "static/apl-background-1647e06c07016b6eff2e4dc5a8efed20.jpg";